import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';

import PropTypes from 'prop-types';
import './styles.css';
import { getMessages } from '../../tppServices/translations/messages';

class ViewCarouselVideos extends PureComponent {
  render (){
    const { intl: { formatMessage } } = this.props;
    const messages = getMessages();
    return (
      <div className="view-videos" onClick={() => {this.props.listingHasImages ? this.props.openCarouselModal(1) : this.props.openCarouselModal(0);}} >{formatMessage(messages.viewCarouselVideos.video)}</div>
    );
  }
}

ViewCarouselVideos.propTypes = {
  images: PropTypes.array,
  openCarouselModal: PropTypes.func,
  listingHasImages: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired
};

export default (injectIntl(ViewCarouselVideos));
